import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Bali from "./pages/Bali";
import Sitemap from "./pages/Sitemap";
import BlogPost from "./pages/BlogPost";
import Placeholder from "./pages/Placeholder";
import StartJourney from "./components/StartJourney";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/volunteer-in-bali" element={<Bali />} />
          <Route path="/projects/volunteer-in-bali/" element={<Bali />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/sitemap/:page" element={<Sitemap />} />
          <Route path="/find-out-more-about-cape-verde/" element={<BlogPost />} />
          <Route path="/blog/find-out-more-about-cape-verde" element={<BlogPost />} />
          <Route path="*" element={<Placeholder />} />
        </Routes>
        <StartJourney />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
